<template>
  <div>
    <el-button type="primary" plain @click="resetPageParams">{{$t('componentMsg.002')}}</el-button>
    <el-button type="primary" plain @click="saveToPlan">{{$t('componentMsg.003')}}</el-button>
    <el-button type="primary" plain @click="previewQRCode">{{$t('componentMsg.004')}}</el-button>
    <el-button type="primary" @click="exportQRCode">{{$t('componentMsg.005')}}</el-button>
    <el-button type="primary" plain @click="previewJSONFile" v-if="!isProd">{{$t('componentMsg.021')}}</el-button>
    <el-button type="primary" @click="exportJSONFile">{{$t('componentMsg.006')}}</el-button>
  </div>
</template>
<script>
export default {
    data() {
        return {
            isProd: process.env.NODE_ENV === 'production'
        };
    },
    methods:{
        // 重置本页参数
        resetPageParams(){
            // 删除对应页面的数据在本地
            this.$confirm(this.$t('componentMsg.007'), this.$t('componentMsg.008'), {
            confirmButtonText: this.$t('componentMsg.009'),
            cancelButtonText: this.$t('componentMsg.010'),
            type: 'warning'
            }).then(() => {
            // 触发停用父组件的删除事件
            this.$emit('childEvent');
            // 触发自定义删除当前配置参数
            this.$emit('resetPagesData');
            // 触发常用参数的删除事件
            this.$emit('resetCommonData');
            }).catch(() => {
            this.$message({
                type: 'info',
                message: this.$t('componentMsg.011')
            });          
            });
        },
        // 保存为方案
        saveToPlan(){
            this.$emit('handleSavePlan');
            this.$emit('saveAsPlan');
            this.$emit("configSaveAsPlan");
        },
        // 预览二维码
        previewQRCode(){
            this.$emit('fatherPagePreviewQRCode');
            this.$emit("commonFatherPagePreviewQRCode");
            this.$emit('customFatherPagePreviewQRCode');
        },
        // 导出二维码
        exportQRCode(){
            this.$emit('handleDownLoadQRCodeImg');
            this.$emit("handleDownLoadCommonQRCodeImg");
            this.$emit('handleDownLoadCustomQRCodeImg');
        },
        // 导出文件
        exportJSONFile(){
            this.$emit('handleDownLoadQrCodeFile');
            this.$emit('handleDownLoadCommonQrCodeFile');
            this.$emit('handleDownLoadCustomQrCodeFile');
        },
        // 预览文件
        previewJSONFile(){
            this.$emit('handlePreviewQrCodeFile');
            this.$emit('handlePreviewCommonQrCodeFile');
            this.$emit('handlePreviewCustomQrCodeFile');
        }
    }
}
</script>